import dayjs, { OpUnitType, QUnitType } from "dayjs";
import localeEn from "dayjs/locale/en";
import relativeTime from "dayjs/plugin/relativeTime";

interface FormatDateOptions {
  emptyString?: string | null;
  format?: string;
}

export function formatDate(
  date: dayjs.ConfigType,
  { emptyString = null, format = "DD/MM/YYYY" }: FormatDateOptions = {}
) {
  if (!date) return emptyString;
  return dayjs(date).format(format);
}
export function daysAgo(date: dayjs.ConfigType) {
  dayjs.extend(relativeTime).locale(localeEn);
  return dayjs(date).fromNow();
}

export function getDateDifference(date: dayjs.ConfigType, unit?: QUnitType | OpUnitType) {
  const currentTime = dayjs();
  return dayjs(date).diff(currentTime, unit);
}

export const getDaysAgo = (date: dayjs.ConfigType) => {
  if (!date) return null;

  const difference = getDateDifference(date);

  if (difference > 30) return "30+ days";

  return daysAgo(date);
};

export const stripTimezoneOffset = (date: string) => {
  if (date.includes("T")) return date.substring(0, date.indexOf("T"));
  return date;
};
